import React from 'react';

const projects = [
  {
    name: 'Klinik Hipnoterapi',
    category: 'Kesehatan & pengembangan diri',
    description: 'Layanan konseling dan hipnoterapi klinis di Cibubur dan online, melayani Jabodetabek sejak 2012.',
    action: 'Kunjungi situs',
    url: 'https://hipnoterapi.ws',
    mark: 'KH',
    style: 'clinic',
  },
  {
    name: 'ZeroMind',
    category: 'Personal operating system',
    description: 'Temukan nilai hidup, susun Personal Blueprint, dan selaraskan tindakan harian dengan tujuan Anda.',
    action: 'Buka aplikasi',
    url: 'https://zeromind.app?utm_source=candradimuka.id&utm_medium=portfolio',
    mark: 'Z',
    style: 'zeromind',
  },
  {
    name: 'LakuKeras.id',
    category: 'Platform digital',
    description: 'Platform untuk menjual ebook, course, dan tiket event di Indonesia. Daftar gratis, pembayaran dan pengiriman otomatis.',
    action: 'Kunjungi platform',
    url: 'https://lakukeras.id?utm_source=candradimuka.id&utm_medium=portfolio',
    mark: 'LK',
    style: 'lakukeras',
  },
  {
    name: 'InfoSecGuru',
    category: 'Keamanan siber',
    description: 'Informasi dan layanan keamanan siber dari InfoSecGuru.',
    action: 'Kunjungi InfoSecGuru',
    url: 'https://infosecguru.id',
    mark: '盾',
    style: 'infosec',
  },
];

function PortfolioCard({ project, index }) {
  return (
    <article className={`portfolio-card card-${project.style}`}>
      <div className={`project-art art-${project.style}`} aria-hidden="true">
        <span className="project-mark">{project.mark}</span>
        <span className="project-number">0{index + 1}</span>
      </div>
      <div className="project-content">
        <p className="project-category">{project.category}</p>
        <h3>{project.name}</h3>
        <p className="project-description">{project.description}</p>
        <a
          className="project-link"
          href={project.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {project.action}<span aria-hidden="true">↗</span>
        </a>
      </div>
    </article>
  );
}

function PortfolioSection() {
  return (
    <section className="section portfolio-section" id="portofolio" aria-labelledby="portfolio-title">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow eyebrow-dark">Yang kami bangun</p>
          <h2 id="portfolio-title">Portofolio <span>inspiratif.</span></h2>
          <p>Inisiatif yang membantu orang dan bisnis melangkah ke tahap berikutnya.</p>
        </div>
        <div className="portfolio-grid">
          {projects.map((project, index) => (
            <PortfolioCard key={project.name} project={project} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default PortfolioSection;